(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouson-app-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ouson-app-guide')) {
  class OusonAppGuide extends HTMLElement {
    connectedCallback() {
      if (this._ready || !this.querySelector('[data-ohag-screen]')) return;
      this._ready = true;
      this._events = new AbortController();
      const on = (el, event, handler) => el.addEventListener(event, handler, { signal: this._events.signal });
      this._device = this.dataset.device === 'ipad' ? 'ipad' : 'iphone';
      this._chapter = 0;
      this._chapters = [...this.querySelectorAll('[data-ohag-chapter]')];
      this._dialog = this.querySelector('dialog');
      this.classList.add('ohag--enhanced');
      this.querySelectorAll('[data-ohag-enhance]').forEach(el => { el.hidden = false; });
      on(this, 'click', event => {
        const button = event.target.closest('button');
        if (button?.dataset.ohagDevice) this.selectDevice(button.dataset.ohagDevice);
        if (button?.dataset.ohagScan) {
          this.querySelector('[data-ohag-scan-figure]').dataset.scanView = button.dataset.ohagScan;
          this.querySelectorAll('[data-ohag-scan]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          this.updateScreens();
        }
        const link = event.target.closest('[data-ohag-enlarge]');
        if (link && this._dialog?.showModal) {
          event.preventDefault();
          this._returnFocus = link;
          const img = link.querySelector('img');
          const large = this._dialog.querySelector('img');
          large.src = link.href;
          large.alt = img.alt;
          this._dialog.querySelector('h2').textContent = link.closest('figure').querySelector('figcaption').textContent;
          this._dialog.showModal();
        }
        if (button?.hasAttribute('data-ohag-close')) this._dialog.close();
        if (button?.hasAttribute('data-ohag-present')) this.setPresent(!this._presenting);
        if (button?.hasAttribute('data-ohag-exit')) this.setPresent(false);
        if (button?.dataset.ohagStep) this.go(this._chapter + Number(button.dataset.ohagStep));
        const anchor = event.target.closest('[data-ohag-anchor]');
        if (anchor) {
          const target = this.querySelector('[data-ohag-chapter="' + anchor.dataset.ohagAnchor + '"]') || this.querySelector('[data-ohag-directory]');
          if (target) { event.preventDefault(); target.scrollIntoView({ behavior: this.motion(), block: 'start' }); }
        }
      });
      on(this._dialog, 'click', event => {
        if (event.target !== this._dialog) return;
        const r = this._dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this._dialog.close();
      });
      on(this._dialog, 'close', () => this._returnFocus?.focus({ preventScroll: true }));
      on(this, 'keydown', event => {
        if (!this._presenting || this._dialog.open || /INPUT|SELECT|TEXTAREA/.test(event.target.tagName)) return;
        if (['ArrowRight', 'PageDown'].includes(event.key)) { event.preventDefault(); this.go(this._chapter + 1); }
        if (['ArrowLeft', 'PageUp'].includes(event.key)) { event.preventDefault(); this.go(this._chapter - 1); }
        if (event.key === 'Escape') this.setPresent(false);
      });
      this.selectDevice(this._device);
      this.updateCounter();
    }
    disconnectedCallback() {
      this._events?.abort();
      this._ready = false;
      this._presenting = false;
      this.classList.remove('ohag--presenting', 'ohag--enhanced');
    }
    motion() { return this.dataset.motion === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'; }
    selectDevice(device) {
      this._device = device;
      this.dataset.device = device;
      this.querySelectorAll('[data-ohag-device]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ohagDevice === device)));
      this.updateScreens();
    }
    updateScreens() {
      this.querySelectorAll('[data-ohag-screen]').forEach(figure => {
        const scan = figure.hasAttribute('data-ohag-scan-figure');
        const suffix = scan && figure.dataset.scanView === 'scan' ? 'Scan' : '';
        const img = figure.querySelector('img');
        const link = figure.querySelector('[data-ohag-enlarge]');
        const source = figure.dataset[this._device + suffix];
        const full = figure.dataset[this._device + suffix + 'Full'];
        img.src = source;
        link.href = full;
        figure.dataset.device = this._device;
        img.width = this._device === 'ipad' ? 2752 : 1320;
        img.height = this._device === 'ipad' ? 2064 : 2868;
        const label = figure.dataset[this._device + 'Label'];
        figure.querySelector('figcaption').textContent = label;
        img.alt = label;
        img.classList.remove('ohag-swapped');
        void img.offsetWidth;
        img.classList.add('ohag-swapped');
      });
    }
    updateCounter() {
      this.querySelector('[data-ohag-count]').textContent = (this._chapter + 1) + ' / ' + this._chapters.length;
      this.querySelector('[data-ohag-step="-1"]').disabled = this._chapter === 0;
      this.querySelector('[data-ohag-step="1"]').disabled = this._chapter === this._chapters.length - 1;
    }
    go(index) {
      this._chapter = Math.min(this._chapters.length - 1, Math.max(0, index));
      this._chapters[this._chapter].scrollIntoView({ behavior: this.motion(), block: 'start' });
      this.updateCounter();
    }
    setPresent(on) {
      this._presenting = on;
      this.classList.toggle('ohag--presenting', on);
      this.querySelector('[data-ohag-controls]').hidden = !on;
      this.querySelector('[data-ohag-present]').setAttribute('aria-pressed', String(on));
      if (on) {
        this._chapter = 0;
        this.scrollTop = 0;
        this.focus({ preventScroll: true });
        this.updateCounter();
      } else {
        this.querySelector('[data-ohag-present]').focus({ preventScroll: true });
      }
    }
  }
  customElements.define('ouson-app-guide', OusonAppGuide);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouson-calibration-service"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ouson-calibration-service')) {
  customElements.define('ouson-calibration-service', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        const template = this.querySelector('template[data-ui]');
        if (!template) return;
        this.attachShadow({mode:'open'}).append(template.content.cloneNode(true));
      }
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const root = this.shadowRoot;
      const button = root.querySelector('.book-button');
      const dialog = root.querySelector('dialog');
      const frame = root.querySelector('iframe');
      const loadNote = root.querySelector('.booking-load');
      const bookingOrigin = new URL(frame.dataset.bookingSrc).origin;
      let contentHeight = 0;
      let locked = false;
      let previousOverflow = '';
      this.updateWidth = () => {
        const width = document.documentElement.clientWidth;
        const margin = parseFloat(getComputedStyle(this).marginLeft) || 0;
        const left = this.getBoundingClientRect().left - margin;
        this.style.setProperty('--calibration-left', -left + 'px');
        this.style.setProperty('--calibration-width', width + 'px');
      };
      const fitBooking = () => {
        if (contentHeight) frame.style.height = Math.min(contentHeight, window.innerHeight * .9 - 52) + 'px';
      };
      this.restoreScroll = () => {
        if (locked) document.documentElement.style.overflow = previousOverflow;
        locked = false;
      };
      button.addEventListener('click', event => {
        event.preventDefault();
        if (dialog.open) return;
        if (!frame.getAttribute('src')) frame.src = frame.dataset.bookingSrc;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        locked = true;
        dialog.showModal();
        fitBooking();
      }, {signal});
      dialog.addEventListener('close', () => {
        this.restoreScroll();
        button.focus({preventScroll:true});
      }, {signal});
      window.addEventListener('message', event => {
        if (event.source !== frame.contentWindow || event.origin !== bookingOrigin || event.data?.type !== 'ouson-booking-layout') return;
        const height = event.data.height;
        if (!Number.isFinite(height) || height < 100 || height > 20000) return;
        contentHeight = height;
        loadNote.hidden = true;
        fitBooking();
        if (event.data.scrollTop) dialog.scrollTop = 0;
      }, {signal});
      window.addEventListener('resize', fitBooking, {signal});
      window.addEventListener('resize', this.updateWidth, {signal});
      this.updateWidth();
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(this.updateWidth);
      this.resizeObserver.observe(document.documentElement);
      if (document.body) this.resizeObserver.observe(document.body);
      if (this.parentElement) this.resizeObserver.observe(this.parentElement);
      this.setAttribute('data-ready','');
    }
    disconnectedCallback() {
      this.restoreScroll?.();
      this.resizeObserver?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouson-extra-warranty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ouson-extra-warranty')) {
  customElements.define('ouson-extra-warranty', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        const template = this.querySelector('template[data-ui]');
        if (!template) return;
        this.attachShadow({mode: 'open'}).append(template.content.cloneNode(true));
        this.prices = JSON.parse(this.querySelector('[data-prices]').textContent);
      }
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal, root = this.shadowRoot, q = s => root.querySelector(s);
      const text = key => q('[data-text="' + key + '"]').textContent;
      const form = q('#extra-form'), fees = q('.fees-disclosure');
      const preview = this.hasAttribute('data-preview') && ['localhost', '127.0.0.1', ''].includes(location.hostname);
      const money = value => 'RM' + value.toFixed(2);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const go = target => {
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({behavior: reduced ? 'instant' : 'smooth', block: 'start'});
        (target.tagName === 'DETAILS' ? target.querySelector('summary') : target).focus({preventScroll: true});
      };
      const updateQuote = () => {
        const model = this.prices.find(p => p.model === form.elements.model.value);
        const months = form.elements.extension_months.value;
        q('.quote-prices').hidden = !model || !months;
        q('[data-quote-hint]').textContent = !model ? text('select_product') : !months ? text('select_plan') : model.model + ' · ' + text(months === '12' ? 'year1' : 'year2');
        if (model && months) {
          q('[data-quote-standard]').textContent = money(model['standard' + months]);
          q('[data-quote-early]').textContent = money(model['early' + months]);
        }
      };
      root.addEventListener('click', event => {
        const anchor = event.target.closest('[data-anchor]');
        if (anchor) { event.preventDefault(); go(q('#' + anchor.dataset.anchor)); }
        const period = event.target.closest('[data-fee-switch]');
        if (period) {
          root.querySelectorAll('[data-fee-switch]').forEach(button => button.setAttribute('aria-pressed', String(button === period)));
          root.querySelectorAll('[data-fee-period]').forEach(item => { item.hidden = item.dataset.feePeriod !== period.dataset.feeSwitch; });
        }
        const help = event.target.closest('[data-help]');
        if (help) {
          const panel = q('#' + help.getAttribute('aria-controls'));
          panel.hidden = !panel.hidden;
          help.setAttribute('aria-expanded', String(!panel.hidden));
          if (!panel.hidden) {
            const image = panel.querySelector('[data-src]');
            if (image) { image.src = image.dataset.src; image.removeAttribute('data-src'); }
          }
        }
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) {
          const panel = q('#' + zoom.dataset.zoom + '-help');
          const zoomed = panel.classList.toggle('zoomed');
          zoom.setAttribute('aria-pressed', String(zoomed));
          zoom.textContent = text(zoomed ? 'zoom_out' : 'zoom_in');
          if (!zoomed) panel.querySelector('.guide-viewport').scrollLeft = 0;
        }
      }, {signal});
      const feesLabel = () => { q('[data-fee-action]').textContent = text(fees.open ? 'fees_close' : 'fees_action'); };
      fees.addEventListener('toggle', feesLabel, {signal});
      feesLabel();
      form.addEventListener('change', updateQuote, {signal});
      root.querySelectorAll('[data-preview-note]').forEach(note => { note.hidden = !preview; });
      const button=q('.submit-button'),message=q('.form-message'),verification=this.querySelector('[slot="verification"]'),retry=q('[data-retry-verification]');
      this.requestId ||= crypto.randomUUID();this.token='';
      const enable=()=>{button.disabled=!!this.busy||(!preview&&!this.token);button.textContent=text(this.busy?'submitting':'submit');};
      const failed=()=>{this.token='';message.textContent=text('verification_error');retry.hidden=false;enable();};
      const renderVerification=async()=>{
        this.token='';retry.hidden=true;enable();
        if(preview)return;
        if(window.Shopify?.designMode){verification.textContent=text('editor_preview');return;}
        try{
          await this.constructor.loadVerification();if(signal.aborted)return;
          if(this.widget!=null)window.turnstile.remove(this.widget);
          this.widget=window.turnstile.render(verification,{sitekey:'0x4AAAAAAErG1sPCJOAi-7p5',action:'extended-warranty',theme:'light',size:verification.clientWidth<300?'compact':'normal',
            callback:token=>{if(!signal.aborted){this.token=token;retry.hidden=true;if(message.textContent===text('verification_error'))message.textContent='';enable();}},
            'expired-callback':()=>{if(!signal.aborted){this.token='';enable();window.turnstile.reset(this.widget);}},
            'error-callback':()=>{if(!signal.aborted)failed();}
          });
        }catch{if(!signal.aborted)failed();}
      };
      retry.addEventListener('click',renderVerification,{signal});
      // Load verification only as the user approaches the form.
      this.verificationObserver?.disconnect();
      this.verificationObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.verificationObserver.disconnect();renderVerification();}},{rootMargin:'500px'});
      this.verificationObserver.observe(q('.verification'));enable();
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(this.busy||(!preview&&!this.token)||!form.reportValidity())return;
        const payload=Object.fromEntries(new FormData(form));delete payload['cf-turnstile-response'];
        for(const field of ['email_consent','standard_registered','terms_consent'])payload[field]=form.elements[field].checked;
        payload.extension_months=Number(payload.extension_months);
        const snapshot=JSON.stringify(payload);if(this.requestSnapshot&&this.requestSnapshot!==snapshot)this.requestId=crypto.randomUUID();this.requestSnapshot=snapshot;
        payload.requestId=this.requestId;payload.captchaToken=this.token;
        this.busy=true;enable();message.textContent='';
        try{
          let result={reference:'EW-PREVIEW'};
          if(!preview){
            const response=await fetch('https://ynqngbgrohgmaxulyols.supabase.co/functions/v1/extended-warranty',{method:'POST',headers:{'Content-Type':'application/json',apikey:'sb_publishable_h3DmrEurXQn4TmaDbr3aaA_P7NAkQQv'},body:JSON.stringify({action:'submit',payload}),signal:AbortSignal.timeout(25000)});
            result=await response.json();if(!response.ok)throw new Error(result.error||text('submit_error'));
            if(!/^EW-\d+$/.test(result.reference||''))throw new Error(text('submit_error'));
          }
          if(signal.aborted)return;
          form.hidden=true;verification.hidden=true;q('.before-you-begin').hidden=true;q('.success').hidden=false;
          q('.reference').textContent=text('reference')+': '+result.reference;
          const notice=q('[data-email-notice]');notice.hidden=preview||!payload.email_consent;notice.textContent=text('email_notice').replace('[email]',payload.email);
          go(q('.success'));
        }catch(error){
          if(!signal.aborted){message.textContent=error.name==='TimeoutError'?text('timeout'):error.message;this.token='';if(this.widget!=null&&window.turnstile)window.turnstile.reset(this.widget);}
        }finally{this.busy=false;enable();}
      },{signal});
      q('[data-reset]').addEventListener('click',()=>{
        form.reset();this.requestSnapshot=null;this.requestId=crypto.randomUUID();updateQuote();
        form.hidden=false;verification.hidden=false;q('.before-you-begin').hidden=false;q('.success').hidden=true;
        renderVerification();go(q('#extra-application'));
      },{signal});
      this.updateWidth = () => {
        const width = document.documentElement.clientWidth;
        const margin = parseFloat(getComputedStyle(this).marginLeft) || 0;
        const left = this.getBoundingClientRect().left - margin;
        this.style.setProperty('--extra-left', -left + 'px');
        this.style.setProperty('--extra-width', width + 'px');
      };
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(this.updateWidth);
      this.resizeObserver.observe(document.documentElement);
      if (document.body) this.resizeObserver.observe(document.body);
      if (this.parentElement) this.resizeObserver.observe(this.parentElement);
      window.addEventListener('resize', this.updateWidth, {signal});
      this.updateWidth();
      updateQuote();
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.abort?.abort();
      this.verificationObserver?.disconnect();
      if(this.widget!=null&&window.turnstile)window.turnstile.remove(this.widget);
      this.widget=null;
    }
    static loadVerification() {
      if (window.turnstile?.render) return Promise.resolve();
      if (this.verificationPromise) return this.verificationPromise;
      this.verificationPromise = new Promise((resolve, reject) => {
        let script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
        const timeout = setTimeout(() => finish(false), 20000);
        const finish = ok => { clearTimeout(timeout); ok ? resolve() : reject(new Error('Verification unavailable')); };
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true; script.defer = true;
          script.addEventListener('load', () => finish(!!window.turnstile?.render), {once:true});
          script.addEventListener('error', () => { script.remove(); finish(false); }, {once:true});
          document.head.append(script);
        } else {
          script.addEventListener('load', () => finish(!!window.turnstile?.render), {once:true});
          script.addEventListener('error', () => finish(false), {once:true});
          if (window.turnstile?.render) finish(true);
        }
      }).catch(error => { this.verificationPromise = null; throw error; });
      return this.verificationPromise;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouson-health-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ouson-health-page')) {
  customElements.define('ouson-health-page', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        const ui = this.querySelector('template[data-ui]');
        if (!ui) return;
        this.attachShadow({ mode: 'open' }).append(ui.content.cloneNode(true));
      }
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const root = this.shadowRoot;
      const query = selector => root.querySelector(selector);
      this.frame = query('.ouson-root');
      this.art = query('.art');
      this.tabs = [...root.querySelectorAll('[role="tab"]')];
      this.active = Number(this.active || 0);
      this.motion = this.motion ?? (this.dataset.motion !== 'false');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.updateMotion = () => {
        const paused = !this.motion || this.reduced.matches;
        this.frame.classList.toggle('paused', paused);
        const button = query('[data-motion-toggle]');
        button.textContent = this.reduced.matches ? this.dataset.reducedLabel : (this.motion ? this.dataset.pauseLabel : this.dataset.enableLabel);
        button.setAttribute('aria-pressed', String(paused));
        button.disabled = this.reduced.matches;
      };
      this.reduced.addEventListener('change', this.updateMotion, { signal });
      this.updateMotion();
      query('[data-motion-toggle]').addEventListener('click', () => {
        this.motion = !this.motion;
        this.updateMotion();
      }, { signal });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', event => {
          const next = { ArrowRight: (index + 1) % 5, ArrowLeft: (index + 4) % 5, Home: 0, End: 4 }[event.key];
          if (next !== undefined) {
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }
        }, { signal });
      });
      query('[data-replay]').addEventListener('click', () => this.select(this.active), { signal });
      query('.explore').addEventListener('click', event => {
        event.preventDefault();
        query('#features').scrollIntoView({ behavior: this.motion && !this.reduced.matches ? 'smooth' : 'auto', block: 'start' });
        this.tabs[this.active].focus({ preventScroll: true });
      }, { signal });
      this.resize?.disconnect();
      this.resize = new ResizeObserver(() => this.fit());
      this.resize.observe(this);
      this.select(this.active);
      this.setAttribute('data-ready', '');
    }
    fit() {
      if (!this.isConnected) return;
      const width = this.getBoundingClientRect().width;
      this.shadowRoot.querySelector('.hero').style.setProperty('--hero-scale', width / 1800);
      const viewBoxes = ['780 100 845 790', '665 95 950 790', '790 115 840 780', '785 115 835 780', '795 115 825 780'];
      this.art.querySelector('svg')?.setAttribute('viewBox', width <= 700 ? viewBoxes[this.active] : '0 95 1672 815');
    }
    select(index) {
      this.active = index;
      const root = this.shadowRoot;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      root.querySelector('.pill').style.transform = `translateX(${index * 100}%)`;
      root.querySelector('[role="tabpanel"]').setAttribute('aria-labelledby', this.tabs[index].id);
      const template = root.querySelectorAll('template[data-feature]')[index];
      root.querySelector('.mobile-copy').replaceChildren(template.content.querySelector('[data-copy]').cloneNode(true));
      const svg = template.content.querySelector('svg').cloneNode(true);
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', this.tabs[index].dataset.description);
      svg.querySelectorAll('g[transform]').forEach((node, i) => {
        node.classList.add('card');
        node.style.animationDelay = `${i * 0.12}s`;
      });
      svg.querySelectorAll('g[stroke-dasharray] path').forEach(node => node.classList.add('connector'));
      if (index === 0) {
        const ns = 'http://www.w3.org/2000/svg';
        const defs = document.createElementNS(ns, 'defs');
        const clip = document.createElementNS(ns, 'clipPath');
        clip.id = 'ouson-lcd';
        const polygon = document.createElementNS(ns, 'polygon');
        polygon.setAttribute('points', '969,411 1061,422 1043,529 947,517');
        clip.append(polygon);
        defs.append(clip);
        const group = document.createElementNS(ns, 'g');
        group.setAttribute('clip-path', 'url(#ouson-lcd)');
        const line = document.createElementNS(ns, 'path');
        line.setAttribute('class', 'scan');
        line.setAttribute('d', 'M930 412L1080 429');
        line.setAttribute('stroke', '#76ddff');
        line.setAttribute('stroke-width', '3');
        group.append(line);
        svg.append(defs, group);
        svg.querySelector('g[transform="translate(1148 613)"]')?.classList.add('detected');
      }
      this.art.replaceChildren(svg);
      this.fit();
      this.intersection?.disconnect();
      this.art.classList.remove('in-view');
      this.intersection = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.art.classList.add('in-view');
          this.intersection.disconnect();
        }
      }, { threshold: 0.15 });
      this.intersection.observe(this.art);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouson-reseller-program"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ouson-reseller-program')) {
  customElements.define('ouson-reseller-program', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        const template = this.querySelector('template[data-ui]');
        if (!template) return;
        this.attachShadow({mode:'open'}).append(template.content.cloneNode(true));
      }
      this.abort?.abort(); this.abort = new AbortController();
      const signal=this.abort.signal, root=this.shadowRoot, q=s=>root.querySelector(s), all=s=>[...root.querySelectorAll(s)];
      const form=q('form'), panels=all('[data-panel]'), progress=all('[data-step]');
      const txt=k=>q('[data-text="'+k+'"]').textContent;
      const preview=this.hasAttribute('data-preview')&&['localhost','127.0.0.1',''].includes(location.hostname);
      const message=q('.form-message');
      this.step=1;this.maxStep=1;
      const scrollTo=el=>el.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
      const show=step=>{
        this.step=step;this.maxStep=Math.max(step,this.maxStep);
        panels.forEach(p=>p.hidden=Number(p.dataset.panel)!==step);
        progress.forEach(b=>{const n=Number(b.dataset.step);b.disabled=n>this.maxStep;b.toggleAttribute('aria-current',n===step);if(n===step)b.setAttribute('aria-current','step');b.parentElement.classList.toggle('completed',n<step);});
        q('[data-prev]').hidden=step===1;q('[data-next]').hidden=step===4;q('[data-submit]').hidden=step!==4;
        message.textContent=''; if(step===4){review();if(!this.verificationStarted){this.verificationStarted=true;renderVerification();}}
        const heading=q('[data-panel="'+step+'"] h3');heading.focus({preventScroll:true});
      };
      const validate=(step,report=true)=>{
        for(const field of panels[step-1].querySelectorAll('input,select')){
          if(field.willValidate&&!field.checkValidity()){if(report){message.textContent=txt('required_error');field.reportValidity();field.focus();}return false;}
        }
        return true;
      };
      const value=name=>{
        const el=form.elements[name];
        if(el.type==='checkbox')return txt(el.checked?'yes':'no');
        if(el.type==='file')return el.files[0]?.name||txt('not_provided');
        return el.value.trim()||txt('not_provided');
      };
      const review=()=>{all('[data-review]').forEach(e=>e.textContent=value(e.dataset.review));q('[data-review-phone]').textContent=form.elements.country_code.value+' '+form.elements.phone.value;q('[data-review-state]').textContent=value(form.elements.country.value==='Malaysia'?'state_select':'state_other');};
      const countryChange=()=>{
        const select=form.elements.state_select, input=form.elements.state_other;
        const malaysia=form.elements.country.value==='Malaysia';
        select.hidden=!malaysia;select.disabled=!malaysia;select.required=malaysia;
        input.hidden=malaysia;input.disabled=malaysia;input.required=!malaysia;
      };
      form.elements.country.addEventListener('change',countryChange,{signal});countryChange();
      const file=form.elements.certificate;
      const fileChanged=()=>{
        const f=file.files[0];file.setCustomValidity(f&&f.size>10*1024*1024?txt('file_error'):f&&!/\.(pdf|jpe?g|png)$/i.test(f.name)?txt('file_type_error'):'');
        q('[data-file-status]').textContent=f?f.name+' · '+(f.size/1024/1024).toFixed(2)+' MB':txt('file_empty');
        q('[data-remove-file]').hidden=!f;
        if(f&&!file.checkValidity()){file.reportValidity();q('[data-file-status]').textContent=txt('file_error');}
      };
      file.addEventListener('change',fileChanged,{signal});
      const today=new Date();form.elements.incorporation_date.max=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
      root.addEventListener('click',e=>{
        if(this.busy)return;
        const anchor=e.target.closest('[data-anchor]');if(anchor){e.preventDefault();scrollTo(q('#reseller-application'));}
        if(e.target.closest('[data-next]')&&validate(this.step)){show(this.step+1);scrollTo(q('.progress'));}
        if(e.target.closest('[data-prev]')){show(this.step-1);scrollTo(q('.progress'));}
        const step=e.target.closest('[data-step]');if(step){const n=Number(step.dataset.step);if(n<=this.step||validate(this.step)){show(n);scrollTo(q('.progress'));}}
        const edit=e.target.closest('[data-edit]');if(edit){show(Number(edit.dataset.edit));scrollTo(q('.progress'));}
        if(e.target.closest('[data-remove-file]')){file.value='';fileChanged();}
        if(e.target.closest('[data-back-review]')){q('.success').hidden=true;q('[data-form-body]').hidden=false;this.querySelector('[slot="verification"]').hidden=false;show(4);scrollTo(q('.progress'));}
      },{signal});
      const verification=this.querySelector('[slot="verification"]'),button=q('[data-submit]'),retry=q('[data-retry-verification]');
      this.requestId ||= crypto.randomUUID();this.token='';this.verificationStarted=false;
      const enable=()=>{button.disabled=!!this.busy||(!preview&&!this.token);button.innerHTML='';button.textContent=txt(this.busy?'submitting':'submit');};
      const failed=()=>{this.token='';message.textContent=txt('verification_error');retry.hidden=false;enable();};
      const renderVerification=async()=>{
        this.token='';retry.hidden=true;enable();
        if(preview){verification.textContent='Local preview';return;}
        if(window.Shopify?.designMode){verification.textContent=txt('editor_preview');return;}
        try{
          await this.constructor.loadVerification();if(signal.aborted)return;
          if(this.widget!=null)window.turnstile.remove(this.widget);
          this.widget=window.turnstile.render(verification,{sitekey:'0x4AAAAAAErG1sPCJOAi-7p5',action:'reseller-application',theme:'light',size:verification.clientWidth<300?'compact':'normal',
            callback:token=>{if(!signal.aborted){this.token=token;retry.hidden=true;if(message.textContent===txt('verification_error'))message.textContent='';enable();}},
            'expired-callback':()=>{if(!signal.aborted){this.token='';enable();window.turnstile.reset(this.widget);}},
            'error-callback':()=>{if(!signal.aborted)failed();}
          });
        }catch{if(!signal.aborted)failed();}
      };
      retry.addEventListener('click',renderVerification,{signal});enable();
      form.addEventListener('submit',async e=>{
        e.preventDefault();if(this.busy)return;
        if(this.step<4){if(validate(this.step)){show(this.step+1);scrollTo(q('.progress'));}return;}
        for(let step=1;step<=3;step++){if(!validate(step,false)){show(step);validate(step);return;}}
        if(!preview&&!this.token)return;
        const payload=Object.fromEntries(new FormData(form));delete payload.certificate;delete payload['cf-turnstile-response'];
        for(const name of ['pic_email_consent','primary_email_consent','secondary_email_consent','term1','term2','term3','term4','term5'])payload[name]=form.elements[name].checked;
        payload.state=form.elements.country.value==='Malaysia'?form.elements.state_select.value:form.elements.state_other.value;
        delete payload.state_select;delete payload.state_other;payload.terms_version='2026-09-14-v1';
        this.busy=true;enable();const controls=[...form.querySelectorAll('input,select,textarea,button')];const disabled=controls.map(e=>e.disabled);controls.forEach(e=>e.disabled=true);message.textContent='';
        try{
          const selected=file.files[0];const hash=[...new Uint8Array(await crypto.subtle.digest('SHA-256',await selected.arrayBuffer()))].map(n=>n.toString(16).padStart(2,'0')).join('');
          const fingerprint=JSON.stringify(payload)+selected.name+hash;if(this.requestSnapshot&&this.requestSnapshot!==fingerprint)this.requestId=crypto.randomUUID();this.requestSnapshot=fingerprint;
          let result={reference:'RA-PREVIEW'};
          if(!preview){
            const body=new FormData();body.set('payload',JSON.stringify({...payload,requestId:this.requestId,captchaToken:this.token}));body.set('certificate',selected);
            const response=await fetch('https://ynqngbgrohgmaxulyols.supabase.co/functions/v1/reseller-applications',{method:'POST',headers:{apikey:'sb_publishable_h3DmrEurXQn4TmaDbr3aaA_P7NAkQQv'},body,signal:AbortSignal.timeout(65000)});
            result=await response.json();if(!response.ok){if(['IDEMPOTENCY_CONFLICT','REQUEST_EXPIRED'].includes(result.code)){this.requestId=crypto.randomUUID();this.requestSnapshot=null;}throw new Error(result.code==='TERMS_CHANGED'?txt('terms_updated'):result.error||txt('submit_error'));}
            if(!/^RA-\d+$/.test(result.reference||''))throw new Error(txt('submit_error'));
          }
          if(signal.aborted)return;
          q('[data-form-body]').hidden=true;q('.success').hidden=false;verification.hidden=true;
          if(!preview){q('.success h2').textContent=txt('success_heading');q('[data-success-description]').textContent=txt('success_description');q('[data-back-review]').hidden=true;}
          const reference=q('.application-reference');reference.hidden=false;reference.textContent=txt('application_reference')+': '+result.reference;
          const notice=q('[data-email-notice]');notice.hidden=preview||!payload.pic_email_consent;notice.textContent=txt('email_notice').replace('[email]',payload.email);
          q('.success h2').focus({preventScroll:true});scrollTo(q('#reseller-application'));
        }catch(error){if(!signal.aborted){message.textContent=error.name==='TimeoutError'?txt('timeout'):error.message;this.token='';if(this.widget!=null&&window.turnstile)window.turnstile.reset(this.widget);}}
        finally{this.busy=false;controls.forEach((e,i)=>e.disabled=disabled[i]);enable();}
      },{signal});
      all('[data-preview-note]').forEach(e=>e.hidden=!preview);
      const thermometerRegion=[[1598,90],[2005,90],[2005,397],[1880,397],[1843,405],[1825,423],[1790,484],[1775,512],[1733,438],[1710,389],[1690,368],[1667,365],[1598,379]];
      const clipThermometerEdit=()=>{
        all('.hero-edit').forEach(image=>{
          const rect=image.getBoundingClientRect();if(!rect.width||!rect.height)return;
          const scale=Math.max(rect.width/2048,rect.height/768);
          const left=image.classList.contains('hero-mobile-image')?rect.width-2048*scale:(rect.width-2048*scale)/2;
          const top=(rect.height-768*scale)/2;
          image.style.clipPath='polygon('+thermometerRegion.map(([x,y])=>(x*scale+left)+'px '+(y*scale+top)+'px').join(',')+')';
          image.setAttribute('data-clipped','');
        });
      };
      this.updateWidth=()=>{
        const width=document.documentElement.clientWidth,margin=parseFloat(getComputedStyle(this).marginLeft)||0;
        const left=this.getBoundingClientRect().left-margin;
        this.style.setProperty('--reseller-left',-left+'px');this.style.setProperty('--reseller-width',width+'px');clipThermometerEdit();
      };
      this.observer?.disconnect();this.observer=new ResizeObserver(this.updateWidth);
      this.observer.observe(document.documentElement);if(this.parentElement)this.observer.observe(this.parentElement);
      window.addEventListener('resize',this.updateWidth,{signal});
      this.updateWidth();this.setAttribute('data-ready','');
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();if(this.widget!=null&&window.turnstile)window.turnstile.remove(this.widget);this.widget=null;}
    static loadVerification() {
      if (window.turnstile?.render) return Promise.resolve();
      if (this.verificationPromise) return this.verificationPromise;
      this.verificationPromise = new Promise((resolve, reject) => {
        let script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
        const timeout = setTimeout(() => finish(false), 20000);
        const finish = ok => { clearTimeout(timeout); ok ? resolve() : reject(new Error('Verification unavailable')); };
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true; script.defer = true;
          script.addEventListener('load', () => finish(!!window.turnstile?.render), {once:true});
          script.addEventListener('error', () => { script.remove(); finish(false); }, {once:true});
          document.head.append(script);
        } else {
          script.addEventListener('load', () => finish(!!window.turnstile?.render), {once:true});
          script.addEventListener('error', () => finish(false), {once:true});
          if (window.turnstile?.render) finish(true);
        }
      }).catch(error => { this.verificationPromise = null; throw error; });
      return this.verificationPromise;
    }

  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ouson-warranty-claim"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ouson-warranty-claim')) {
  customElements.define('ouson-warranty-claim', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        this.attachShadow({mode: 'open'}).append(this.querySelector('template[data-ui]').content.cloneNode(true));
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.requestId = crypto.randomUUID();
        this.requestSnapshot = null;
      }
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal, root = this.shadowRoot, q = s => root.querySelector(s);
      const config = this.config, text = config.text, form = q('#warranty-claim-form');
      const button = q('#submit-claim'), message = q('#claim-form-message');
      const verification = this.querySelector('[slot="verification"]');
      const esc = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
      this.token = '';
      const enable = () => { button.disabled = !!this.busy || !this.token; button.textContent = this.busy ? text.submitting : text.submit; };
      const issueOptions = () => {
        const product = config.schema.products.find(p => p.model === form.elements.model.value);
        if (!product) return;
        const select = q('#issue-options');
        select.disabled = false;
        select.innerHTML = '<option value="">' + esc(text.select_problem) + '</option>' + product.issues.map(i => '<option value="' + esc(i) + '">' + esc(i) + '</option>').join('');
      };
      if (!this.hasAttribute('data-ready')) {
        q('#country-code').innerHTML = config.schema.countryCodes.map(code => '<option>' + esc(code) + '</option>').join('');
        q('#purchase-sources').insertAdjacentHTML('beforeend', config.schema.sources.map(source => '<option value="' + esc(source) + '">' + esc(source) + '</option>').join(''));
        q('#products').innerHTML = config.schema.products.map(product => '<label class="product"><img src="' + esc(config.images[product.model]) + '" alt="" width="160" height="160" loading="lazy"><span class="product-choice"><input type="radio" name="model" value="' + esc(product.model) + '" required><span>' + esc(product.label) + '</span></span></label>').join('');
        this.setAttribute('data-ready', '');
      }
      form.addEventListener('change', event => { if (event.target.name === 'model') issueOptions(); }, {signal});
      form.addEventListener('click', event => {
        const help = event.target.closest('[data-help]');
        if (help) {
          const panel = q('#' + help.dataset.help + '-help');
          panel.hidden = !panel.hidden;
          help.setAttribute('aria-expanded', String(!panel.hidden));
          const image = panel.querySelector('img');
          if (!panel.hidden && !image.getAttribute('src')) image.src = image.dataset.src;
        }
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) {
          const on = zoom.getAttribute('aria-pressed') !== 'true';
          q('#' + zoom.dataset.zoom + '-help').classList.toggle('zoomed', on);
          zoom.setAttribute('aria-pressed', String(on));
          zoom.textContent = on ? text.fit_image : text.zoom_in;
        }
      }, {signal});
      const retry = q('#retry-verification');
      const verificationFailed = () => { this.token = ''; message.textContent = text.verification_error; retry.hidden = false; enable(); };
      const renderVerification = async () => {
        retry.hidden = true;
        this.token = '';
        enable();
        if (window.Shopify?.designMode) {
          verification.textContent = text.editor_preview;
          return;
        }
        try {
          await this.constructor.loadVerification();
          if (signal.aborted) return;
          if (this.widget != null) window.turnstile.remove(this.widget);
          this.widget = window.turnstile.render(verification, {
            sitekey: '0x4AAAAAAErG1sPCJOAi-7p5', action: 'warranty-claim', theme: 'light',
            size: verification.clientWidth < 300 ? 'compact' : 'normal',
            callback: token => { if (!signal.aborted) { this.token = token; if (message.textContent === text.verification_error) message.textContent = ''; retry.hidden = true; enable(); } },
            'expired-callback': () => { if (!signal.aborted) { this.token = ''; enable(); window.turnstile.reset(this.widget); } },
            'error-callback': () => { if (!signal.aborted) verificationFailed(); }
          });
        } catch { if (!signal.aborted) verificationFailed(); }
      };
      retry.addEventListener('click', renderVerification, {signal});
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !this.token || !form.reportValidity()) return;
        const payload = Object.fromEntries(new FormData(form));
        delete payload['cf-turnstile-response'];
        for (const field of ['email_consent','return_notice','support_notice']) payload[field] = form.elements[field].checked;
        const snapshot = JSON.stringify(payload);
        if (this.requestSnapshot && this.requestSnapshot !== snapshot) this.requestId = crypto.randomUUID();
        this.requestSnapshot = snapshot;
        payload.requestId = this.requestId;
        payload.captchaToken = this.token;
        this.busy = true; enable(); message.textContent = '';
        try {
          const response = await fetch('https://ynqngbgrohgmaxulyols.supabase.co/functions/v1/warranty-claims', {
            method: 'POST', headers: {'Content-Type':'application/json', apikey:'sb_publishable_h3DmrEurXQn4TmaDbr3aaA_P7NAkQQv'},
            body: JSON.stringify({action:'submit',payload}), signal: AbortSignal.timeout(25000)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.error || text.submit_error);
          if (!result.reference) throw new Error(text.submit_error);
          form.hidden = true;
          verification.hidden = true;
          q('#claim-reference').textContent = text.reference + ' ' + result.reference;
          const notice = q('#claim-email-notice');
          notice.hidden = !payload.email_consent;
          notice.textContent = text.email_notice.replace('[email]', payload.email);
          q('#claim-success .support-link').href = 'https://wa.me/601133338028?text=' + encodeURIComponent(text.whatsapp_message.replace('[reference]', result.reference));
          const success = q('#claim-success');
          success.hidden = false;
          success.focus({preventScroll:true});
          success.scrollIntoView({behavior:'smooth',block:'center'});
        } catch (error) {
          message.textContent = error.name === 'TimeoutError' ? text.timeout : error.message;
          this.token = '';
          if (this.widget != null && window.turnstile) window.turnstile.reset(this.widget);
        } finally { this.busy = false; enable(); }
      }, {signal});
      this.widthObserver?.disconnect();
      const fitWidth = () => {
        const pageWidth = document.documentElement.clientWidth;
        this.style.setProperty('--claim-page-width', pageWidth + 'px');
        this.style.setProperty('--claim-left-offset', '0px');
        const x = this.getBoundingClientRect().left;
        this.style.setProperty('--claim-left-offset', -x + 'px');
      };
      this.widthObserver = new ResizeObserver(fitWidth);
      this.widthObserver.observe(document.documentElement);
      fitWidth();
      enable();
      this.verificationObserver?.disconnect();
      this.verificationObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.verificationObserver.disconnect();
          renderVerification();
        }
      }, {rootMargin:'400px'});
      this.verificationObserver.observe(verification);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.widthObserver?.disconnect();
      this.verificationObserver?.disconnect();
      if (this.widget != null && window.turnstile) window.turnstile.remove(this.widget);
      this.widget = null;
    }
    static loadVerification() {
      if (window.turnstile?.render) return Promise.resolve();
      if (this.verificationPromise) return this.verificationPromise;
      this.verificationPromise = new Promise((resolve, reject) => {
        let script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
        const timeout = setTimeout(() => finish(false), 20000);
        const finish = ok => { clearTimeout(timeout); ok ? resolve() : reject(new Error('Verification unavailable')); };
        if (!script) {
          script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true; script.defer = true;
          script.addEventListener('load', () => finish(!!window.turnstile?.render), {once:true});
          script.addEventListener('error', () => { script.remove(); finish(false); }, {once:true});
          document.head.append(script);
        } else {
          script.addEventListener('load', () => finish(!!window.turnstile?.render), {once:true});
          script.addEventListener('error', () => finish(false), {once:true});
          if (window.turnstile?.render) finish(true);
        }
      }).catch(error => { this.verificationPromise = null; throw error; });
      return this.verificationPromise;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
